import { NgxLoggerLevel } from 'ngx-logger';

export const ownerEnvironment = {
  production: true,
  enableMedicalRecordsV2: true,

  apiUrl: 'https://api.petszel.com/',
  logger: {
    level: NgxLoggerLevel.ERROR,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: true,
  },
};
